import { createRoot } from 'react-dom/client';
import React from 'react';
import { FrontSearchExt } from './FrontSearchExtComponent';
import SubmitEvent = JQuery.SubmitEvent;

/**
 * In the period from march to may there are so much trainings
 * available. The server response gets to big. Hence we scope the
 * response by level, so we reduce the body size.
 *
 * Check if the user has selected a level before submitting the form.
 *
 * The initial level and subject of the form can either be set via the
 * options of the ACF component in de wp-admin or when providing a
 * query parameter in the address bar.
 */
export class FrontSearch {

  private $ExtSearchForms: JQuery<HTMLFormElement>;

  constructor() {
    let initialLevel: string;
    let initialSubject: string;

    const $data = $('[data-acf]');
    this.$ExtSearchForms = $('.front-search__form[name="EXTSearch"]');

    // intercept the submit action
    this.$ExtSearchForms.on('submit',
      /* istanbul ignore next*/ (e: SubmitEvent) => this.onSubmitExtSearchForm(e)
    );

    // Check if the acf data is set in the html:
    // <div data-acf="{'level': 'HAVO', 'subject': 'Engels'}"></div>
    if ($data && $data.data('acf')) {
      let data = $data.data('acf');
      initialLevel = data.level;
      initialSubject = data.subject;
    }

    if ($('[data-container="search-form"]').length) {
      this.renderExtSearchForm(initialLevel, initialSubject);
    }
  }

  /**
   * Before submitting the form, check if the user has provided a level.
   *
   */
  // istanbul ignore next
  public onSubmitExtSearchForm(
    e: SubmitEvent,
    $form = $(e.currentTarget)
  ): void {
    const level = $form.serializeArray().find(input => input.name === 'level');

    if (!level || (level && level.value.trim() === '')) {
      e.preventDefault(); // prevent form from submitting
      $('.js-search-errors').addClass('visible');
      const errorMessage = $('.js-search-level-validation');
      errorMessage
        .css('display', 'block')
        .removeClass('front-search__level-validation--animation');
      window.setTimeout(() =>
        errorMessage.addClass('front-search__level-validation--animation'), 1);
    }
  }

  /**
   * Render the level - subject form
   */
  public renderExtSearchForm(level: string, subject: string): void {
    const root = createRoot($('[data-container="search-form"]')[0]);
    root.render(
      <>
        <FrontSearchExt initialLevel={level} initialSubject={subject}/>
      </>
    );
  }

}
